<ng-template>
   <div lcsSingleSelectPanel [visible]="isPanelVisible">
      @if (isIncludeEmptyOption) {
      <lcs-option></lcs-option>
      } @for (phone of phones | async; track trackBy(phone)) {
      <lcs-option [value]="phone" id="lcs-option-id-{{ phone.phoneId }}">
         {{ phone.phoneType }} - {{ getFormattedDetails(phone) }}
      </lcs-option>
      }
   </div>
</ng-template>
